<template>
  <div>
    <div class="alert-content">
      <div class="alert-message" v-html="message" />
    </div>
    <div class="alert-action">
      <app-btn @click="action(false)" color="dark-blue-grad">{{
        cancelBtnText
      }}</app-btn>
      <div class="spacer px-3"></div>
      <app-btn @click="action(true)" border="bottom" color="yellow-grad">{{
        confirmBtnText
      }}</app-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true
    },
    confirmBtnText: {
      type: String,
      default: "Да"
    },
    cancelBtnText: {
      type: String,
      default: "Отмена"
    }
  },

  mounted() {
    this.startTimeout();
  },

  methods: {
    startTimeout() {
      const delay = parseInt(this.timeout, 0);
      if (!delay) return;

      this.closeTimeout = setTimeout(() => {
        this.$modals.close();
      }, delay);
    },

    action(confirm) {
      this.$modals.close(confirm);
    }
  }
};
</script>

<style lang="scss">
.app-confirm-modal .modal-card {
  padding: 16px;
  max-width: 500px;
}

.app-confirm-modal .alert-content {
  background: rgba(#000a25, 0.5);
  text-align: center;
  font-size: 22px;
  line-height: 28px;
  font-weight: 400;
  color: #fff;
  border-radius: 6px;
  padding: 30px;
  user-select: none;

  b {
    color: #fbc33e;
    font-weight: bold;
  }

  @include breakpoint("xs-only") {
    font-size: 22px;
    line-height: 28px;
  }
}

.alert-action {
  margin-top: 16px;
  display: flex;
  align-items: center;
}
</style>
